export default function Cta() {
  return (
    <section className="mx-auto max-w-6xl px-4 pt-16 md:px-6 md:pt-24">
      <div className="border-t border-line pt-10 text-center">
        <p className="text-xs uppercase tracking-[0.2em] text-muted">第一站，不等二传</p>
        <h3 className="font-display mx-auto mt-4 max-w-3xl text-2xl font-black leading-snug tracking-tight text-ink md:text-4xl">
          想直接上第一轮现场的人，
          <br />
          已经在看 <span className="text-accent">911网最新消息</span>。
        </h3>
        <div className="mx-auto mt-8 flex max-w-md flex-col gap-3 sm:flex-row">
          <a
            href="#timeline"
            className="inline-flex flex-1 items-center justify-center whitespace-nowrap rounded-md bg-accent px-6 py-3 text-sm text-white transition-colors hover:bg-accent-deep"
          >
            回到新瓜时间线
          </a>
          <a
            href="#trust"
            className="inline-flex flex-1 items-center justify-center whitespace-nowrap rounded-md border border-line-strong px-6 py-3 text-sm text-ink transition-colors hover:border-accent hover:text-accent"
          >
            看 911网 的报法
          </a>
        </div>
      </div>
    </section>
  );
}